// extracted by mini-css-extract-plugin
module.exports = {"div":"AppFooter__div___3gaGs","absolute":"AppFooter__absolute___15ysI","spacer":"AppFooter__spacer___2W_3M"};